<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import { useNavigationsStore } from '@/stores/useNavigationsStore';
import { useSidebarsStore } from '@/stores/useSidebarsStore';
import { useTabsStore } from '@/stores/useTabsStore';

const tabsStore = useTabsStore();
const sidebarsStore = useSidebarsStore();
const navigationsStore = useNavigationsStore();

function handleBackClick(): void {
  tabsStore.tabs.helpcenter = 'browse';
  navigationsStore.navigations.helpcenterSidebar.pop();
}

function handleCloseClick(): void {
  sidebarsStore.sidebars.helpcenter = false;
}
</script>

<template>
  <header
    :class="$style.helpcenterSideBarHeader"
    data-testid="helpcenterSideBarHeader"
  >
    <div>
      <KBtn
        v-if="navigationsStore.navigations.helpcenterSidebar.length"
        :class="$style.backBtn"
        variant="text"
        prepend-icon="mdi-keyboard-backspace"
        @click="handleBackClick"
      >
        Back
      </KBtn>
    </div>
    <div>
      <KBtn
        :class="$style.closeBtn"
        variant="text"
        icon="mdi-close"
        @click="handleCloseClick"
      />
    </div>
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarHeader {
  display: flex;
  justify-content: space-between;
}
</style>
